<template>
    <div class="col-lg-9 c-content-main">
        <div class="tile">
            <h3 class="tile-title is-line">{{$t('customStatuses')}}</h3>
            <div class="tile-body">
<!--                <custom-status type="customer" :title="$t('customerStatusTitle')" :desc="$t('customerStatusDesc')"></custom-status>-->
                <custom-status type="opp" :title="$t('oppStatusTitle')" :desc="$t('oppStatusDesc')"></custom-status>
            </div>
        </div>
    </div>
    <!--end c-content-main-->
</template>

<script>
    import CustomStatus from './CustomStatus';

    export default {
        components: {CustomStatus},
    };
</script>